import {useContext} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import {ModalState} from '../providers/ModalProvider';

const TableBody = styled.tbody`
  & > tr:last-child > td {
    border-bottom: none;
  }
`;

const ModalTable = ({tableHeaders, tableData}) => {
  return (
    <Modal.Body>
      <Table>
        <thead>
          <tr>
            {tableHeaders.map((header, i) => (
              <th key={i}>{header}</th>
            ))}
          </tr>
        </thead>
        <TableBody>
          {tableData.map((row, i) => (
            <tr key={i}>
              {Array.isArray(row) ? row.map((cell, i) => (
                <td key={i}>{cell}</td>
              )) : <td>{row}</td>}
            </tr>
          ))}
        </TableBody>
      </Table>
    </Modal.Body>
  );
};

ModalTable.propTypes = {
  tableHeaders: PropTypes.array.isRequired,
  tableData: PropTypes.array.isRequired,
};

const ModalContainer = styled(Modal)`
  z-index: 100000000;
  color: ${({ theme }) => theme && theme.text ? theme.text.secondary : ''};
  
  &.show {
    opacity: 1;
  }
`;

const ModalCmp = () => {
  const {state: modalState} = useContext(ModalState);

  const modalType = modalState && modalState.modalType ? modalState.modalType : null;
  const open = modalState && modalState.open ? modalState.open : null;
  const title = modalState && modalState.title ? modalState.title : null;
  const message = modalState && modalState.message ? modalState.message : null;
  const actions = modalState && modalState.actions ? modalState.actions : null;
  const handleClose = modalState && modalState.handleClose ? modalState.handleClose : null;
  const handleConfirm = modalState && modalState.handleConfirm ? modalState.handleConfirm : null;
  const tableHeaders = modalState && modalState.tableHeaders ? modalState.tableHeaders : null;
  const tableData = modalState && modalState.tableData ? modalState.tableData : null;
  const buttonText = modalState && modalState.buttonText ? modalState.buttonText : null;

  switch (modalType) {
    case 'options':
      return (
        <ModalContainer centered show={open || false} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{message}</Modal.Body>
          <Modal.Footer>
            {actions.map(action => (
              <Button key={action.text} variant={action.type} onClick={action.handler}>
                {action.text}
              </Button>
            ))}
          </Modal.Footer>
        </ModalContainer>
      );
    case 'table':
      return (
        <ModalContainer centered show={open || false} onHide={handleClose} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <ModalTable tableHeaders={tableHeaders} tableData={tableData} />
        </ModalContainer>
      );
    default:
      return (
        <ModalContainer centered show={open || false} onHide={handleClose} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{message}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleConfirm}>
              {buttonText}
            </Button>
          </Modal.Footer>
        </ModalContainer>
      );
  }
};

export default ModalCmp;
